import { render, staticRenderFns } from "./explainType.vue?vue&type=template&id=56fcb033&scoped=true&"
import script from "./explainType.vue?vue&type=script&lang=js&"
export * from "./explainType.vue?vue&type=script&lang=js&"
import style0 from "./explainType.vue?vue&type=style&index=0&id=56fcb033&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fcb033",
  null
  
)

export default component.exports